import { defineComponent as _defineComponent } from 'vue'
import { inject } from "vue";
import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/userStore";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
  RouterName,
} from "@/types";
import { useRouter } from "vue-router";


const __default__ = {
  name: "Cert",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const userStore = useUserStore();
const route = useRoute();
const router = useRouter();

const serviceCode = route.params?.serviceCode ?? "";

const approveUserSignUp = async () => {
  const certYn = route.query.certYn?.toString();
  const token = route.params.token.toString();

  if (!certYn || !token) {
    showErrorModal(`회원 인증정보 오류`, "회원 인증정보가 올바르지 않습니다.");
    return;
  }

  const userCertResult = await userStore.approveUserSignUp(
    certYn === "true",
    token
  );

  if (userCertResult.resultCode === 404000001) {
    userCertResult.errorMessage =
      "이미 처리된 사용자 이거나 해당 사용자를 찾을 수 없습니다.";
  }
  if (!userCertResult.isSuccess) {
    const certStatus = certYn === "true" ? "승인" : "반려";
    showErrorModal(
      `구성원 인증 ${certStatus} 실패`,
      userCertResult.errorMessage,
      userCertResult.resultCode,
      userCertResult.errorTime
    );
    return;
  }

  const isUserApprove = userCertResult.data?.certYesNo;
  router.push({
    name: isUserApprove ? RouterName.AuthConfirm : RouterName.AuthReject,
  });
  // isUserApprove
  //   ? (window.location.href = `${window.location.origin}/client/${serviceCode}/auth_confirm.html`)
  //   : (window.location.href = `${window.location.origin}/client/${serviceCode}/auth_reject.html`);
};

if (serviceCode) {
  approveUserSignUp();
} else {
  router.push({ name: RouterName.PageNotFound });
}

const __returned__ = { showErrorModal, userStore, route, router, serviceCode, approveUserSignUp }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})